var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftAuthenticator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9994_73615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26305 77H72.7356C75.3498 77 77.4531 74.8791 77.4531 72.2768V4.72319C77.4531 2.10588 75.3347 0 72.7356 0H5.26305C2.64888 0 0.545525 2.12092 0.545525 4.72319V72.2768C0.545525 74.8941 2.64888 77 5.26305 77Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5541 24.0519C24.5541 24.2775 24.5541 24.4881 24.5691 24.7137C26.3119 24.3377 28.1298 24.0368 30.0078 23.7961C30.143 18.9376 34.1094 15.0417 38.9921 15.0417C43.8749 15.0417 47.8563 18.9376 47.9765 23.7961C49.8545 24.0368 51.6723 24.3377 53.4151 24.7137C53.4302 24.4881 53.4302 24.2624 53.4302 24.0368C53.4302 16.0495 46.9699 9.56641 38.9771 9.56641C31.0294 9.59649 24.5541 16.0646 24.5541 24.0519ZM38.932 67.433C13.4214 56.693 17.3126 29.3466 17.3126 29.3466C23.2621 27.1204 30.774 25.7967 38.9621 25.7967C47.1501 25.7967 54.6621 27.1204 60.6116 29.3466C60.6116 29.3466 64.5028 56.693 38.9921 67.433H38.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9015 50.2098C31.9015 50.5257 31.9165 50.8265 31.9616 51.1274H45.979C46.024 50.8265 46.0391 50.5257 46.0391 50.2098C46.0391 47.0209 43.9357 44.3284 41.0361 43.4409C42.9892 42.6286 44.3714 40.7033 44.3714 38.447C44.3714 35.4536 41.9525 33.0469 38.9778 33.0469C36.0031 33.0469 33.5842 35.4686 33.5842 38.447C33.5842 40.7033 34.9664 42.6286 36.9195 43.4409C34.0049 44.3133 31.9015 47.0209 31.9015 50.2098Z",
    fill: "#0078D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9994_73615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    fill: "white",
    transform: "matrix(-1 0 0 1 77.5 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftAuthenticator);
export default __webpack_public_path__ + "static/media/microsoft_authenticator.65e089d7d08f556c6c5a8a2249e0c380.svg";
export { ForwardRef as ReactComponent };